/*
 * @Author       : 程哲林
 * @Date         : 2022-05-25 17:25:06
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-05-23 17:21:51
 * @FilePath     : /marketing-landing-fe/src/locales/zh_TW/index.ts
 * @Description  : 未添加文件描述
 */
export default {
  // 地区滚轮选择器操作文案。
  'cascadingPicker.cancel': '取消',
  'cascadingPicker.confirm': '確定',
  'money.symbol': 'NT$',
  'userEvt.title': '用戶評價',
  'global.check': '檢視全部',
  'userEvt.all': '全部',
  'userEvt.effect': '效果好',
  'userEvt.content': '內容好',
  'userEvt.baby': '孩子喜歡',
  'userEvt.service': '服務好',
  'userEvt.costEffective': '價效比高',
  'userEvt.none': '沒有更多資料了',
  'userEvt.loading': '正在載入資料',
  'landing.page.title': '叫叫',
  'courseSelection.config.title': '确认订单页',
  'courseSelection.telephonecode.title': '選擇國家/地區',
  'courseSelection.telephonecode.commonly': '常用國家/地區',
  'courseSelection.telephonecode.other': '其他國家/地區',
  'courseSelection.phone.title': '手機號',
  'courseSelection.phone.name': '手機號',
  'courseSelection.phone.tip': '將用於領取體驗包',
  'courseSelection.phone.tip1': '已加密',
  'courseSelection.phone.placeholder': '手機號僅作為體驗憑證',
  'courseSelection.code.placeholder': '請輸入驗證碼',
  'courseSelection.code.resend': '重新傳送',
  'courseSelection.code.btn': '發送驗證碼',
  'courseSelection.pack.title': '體驗包信息',
  'courseSelection.pack.title2': '請根據孩子的年級進行選擇',
  'courseSelection.pack.desc1': '科學體系',
  'courseSelection.pack.desc2': '每天15分鐘',
  'courseSelection.pack.payment1': '支付後請及時進入社群獲得體驗包信息',
  'courseSelection.pack.payment2': '支付後請按照頁面提示獲得體驗包信息',
  'courseSelection.pack.tips1': '領取後請及時進入社群獲得體驗包信息',
  'courseSelection.pack.tips2': '領取後請按照頁面提示獲得體驗包信息',
  'courseSelection.buy.btn': '立即購買',
  'courseSelection.free.btn': '免費領取',
  'courseSelection.receive.btn': '{{yuan}}元領取',
  'courseSelection.receive.unavailable': '暫時無法購買',
  'courseSelection.buy.type': '支付方式',
  'courseSelection.buy.wechat': '微信支付',
  'courseSelection.select.text': '已選',
  'courseSelection.toast.correctPhone': '請輸入正確的手機號',
  'courseSelection.toast.codeFail': '傳送驗證碼失敗',
  'courseSelection.toast.receivedIt': '系統異常，請稍後重試',
  'courseSelection.toast.previewFailed': '預覽頁面不能繼續',
  'courseSelection.toast.enterInfo': '請輸入手機號等資訊',
  'courseSelection.toast.loading': '请稍后',
  'courseSelection.toast.autoVerPhone': '手機號自動校驗中...',
  'courseSelection.toast.codeErr': '驗證碼格式錯誤',
  'courseSelection.toast.codeErr2': '驗證碼錯誤',
  'courseSelection.toast.dataErr': '資料錯誤：沒有售賣單id',
  'courseSelection.toast.systemErr': '系統開小差啦，請稍後再試',
  'courseSelection.toast.systemErr2': '出錯了，請稍後再試一下',
  'courseSelection.toast.payFail': '支付失敗!',
  'courseSelection.toast.rePay': '您還沒有支付哦，請重新支付。',
  'courseSelection.toast.dataErr2': '資料獲取錯誤',
  'courseSelection.app.desc': '長按識別小程式碼',
  'courseSelection.app.desc1': '您已經體驗過體驗包了',
  'courseSelection.app.desc2': '可前往下方小程式回顧',
  'courseSelection.prompt.titleFail': '體驗包領取失敗',
  'courseSelection.prompt.ctAlreadyReceived': '3天內有體驗過的體驗包，此時更適合複習回顧哦',
  'courseSelection.prompt.btnKnow': '知道了',
  'courseSelection.prompt.btnActivate': '激活內容',
  'courseSelection.prompt.titleHint': '提示',
  'courseSelection.prompt.titleEnd': '報名已結束',
  'courseSelection.prompt.titleHint2': '溫馨提示',
  'courseSelection.prompt.ctStart': '下期報名即將開始',
  'courseSelection.prompt.ctSellOut': '抱歉，商品已售罄',
  'courseSelection.prompt.titleRecur': '您已有同類內容',
  'courseSelection.prompt.titleNotActivated': '您還有未啟用的體驗包哦',
  'courseSelection.prompt.switchAccounts': '請用主賬戶領取體驗包',
  'courseSelection.prompt.ctAlreadyReceived2': '您已經領過啦',
  'courseSelection.prompt.ctNotSatisfied': '抱歉，您不滿足新使用者領取規則，請退款後前往“愛閱讀的叫叫”公眾號領取',
  'courseSelection.prompt.dissatisfied': '抱歉，您不滿足新使用者領取規則，請退款後前往“愛閱讀的叫叫”公眾號領取',
  'btnButton.btn.txt2': '單獨購買',
  'btnButton.btn.txt3': '一鍵參團',
  'btnButton.tips.joinGroup': '發現超值參團，已為您自動參團哦',
  'askEveryone.title': '熱門問答',
  'askEveryone.reply': '个回覆',
  'group.title': '人正在拼團，可直接參團',
  'group.difference': '僅差1人成團',
  'group.btn.join': '去參團',
  'group.time.left': '剩餘',
  'phone.register': '已報名',
  'phone.register.time': '分鐘',
  'prompt.title.packageNotActivated': '您還有未啟用的體驗包哦',
  'prompt.title.failedToClaim': '體驗包領取失敗',
  'prompt.title.hint': '提示',
  'prompt.content.review': '7天內有體驗過的體驗包，此時更適合複習回顧哦',
  'prompt.content.received': '您已經領過啦',
  'prompt.btn.activation': '激活內容',
  'prompt.btn.know': '知道了',
  'prompt.413Error': '网络异常，请再次输入手机号和获取验证码后重试',
  'payQrCode.alipay': '支付寶',
  'payQrCode.wechat': '微信',
  'payQrCode.pay': '掃碼支付',
  'payQrCode.tips': '若本裝置未安裝{payTxt}，請使用已安裝{payTxt}的裝置掃碼支付',
  'prePayPage.paySuccess': '支付成功',
  'prePayPage.payFail': '支付失敗，請重新掃碼',
  'prePayPage.payUseWx': '請使用微信掃碼',
  'customerService.inline': '客服',
  'customerService.standalone': '聯繫客服'
};